import React from "react";
import { CircularProgressbar, CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
const PayoutCircleChart = ({
  value = 0,
  total = 0,
  theme = "light",
  btcCNVPrice
}) => {
  // Calculate percentage for the progress bar
  const percentage = Math.round((value / total) * 100);

  // Set color based on theme
  const pathColor = "#e9965c";
  const trailColor = theme === "dark" ? "#23293A" : "#eee";
  const textColor = theme === "dark" ? "#fff" : "#23293A";


  return (
    <div style={{ width: 200, height: 200 }}>
      <CircularProgressbarWithChildren
        value={percentage}
        circleRatio={0.75}
        strokeWidth={15}
        styles={buildStyles({
          rotation: 1 / 2 + 1 / 8,
          strokeLinecap: "butt",
          pathColor,
          trailColor,
        })}
      >
        <div style={{ fontSize: 10, fontWeight: 700, color: textColor, textAlign: "center", lineHeight: 1.2 }}>
          <div>${(parseFloat (value).toFixed(2)).toLocaleString()}</div> {/* Bottom line (e.g., USD value) */}
          <div>{(btcCNVPrice != 0 && value != 0) ? (parseFloat(value) / btcCNVPrice).toFixed(8) : 0} BTC</div> {/* Top line (e.g., BTC price) */}
        </div>
      </CircularProgressbarWithChildren>
    </div>
  );
};

export default PayoutCircleChart;